import { useTranslation } from "react-i18next";
import { ProdAttrUtils } from "../../utils/productAttributeUtils";
import UiSection from "../box/UiSection";
import { icAsset } from "../image/image-src";

export const ProductHightlight = ({ d }: { d?: ProductDetailResponse }) => {
  const { t } = useTranslation();

  const highlights = ProdAttrUtils.TOUR.extractHighlight(d?.attributeList);
  if (highlights?.length === 0) return null;
  return (
    <UiSection title={t("Highlights")}>
      <Highlights highlights={highlights} />
    </UiSection>
  );
};

interface HighlightsProps {
  image?: string;
  highlights?: string[];
}

const Highlights: React.FC<HighlightsProps> = ({ image, highlights }) => {
  const renderSchedule = () => {
    return (
      <ul className="flex flex-col gap-[1rem]">
        {!highlights || highlights.length === 0
          ? undefined
          : highlights.map((highlight: string, index: number) => {
              return (
                <li key={index} className="flex gap-[0.625rem]">
                  <img
                    className="mt-[0.1875rem] h-[1.25rem] w-[1.25rem]"
                    src={icAsset("../../../assets/icons/tick-pass.svg")}
                    alt=""
                  />
                  <p className="text-base font-normal leading-[1.625rem]">
                    {highlight}
                  </p>
                </li>
              );
            })}
      </ul>
    );
  };
  return (
    <>
      {image && <img className="w-full" src={image} alt="highlight" />}
      {highlights && highlights.length !== 0 ? renderSchedule() : undefined}
    </>
  );
};
